import { useCallback } from 'react';
import { usePermissions } from './usePermissions';

/**
 * Hook للتحقق من صلاحيات قسم الإعدادات
 * يوفر دوال مساعدة للتحقق من صلاحيات الوصول والإجراءات المختلفة في صفحات الإعدادات
 */
export const useSettingsPermissions = () => {
  const { hasPermission } = usePermissions();
  
  // التحقق من صلاحية الوصول للصفحة
  const hasSettingsPagePermission = useCallback((pageId: string, actionId: string = 'view_page') => {
    return hasPermission('settings', pageId, actionId);
  }, [hasPermission]);

  // التحقق من صلاحية صفحة الفروع
  const hasBranchPermission = useCallback((actionId: string = 'view_page') => {
    return hasPermission('settings', 'branches', actionId);
  }, [hasPermission]);

  // التحقق من صلاحية صفحة الضرائب
  const hasTaxPermission = useCallback((actionId: string = 'view_page') => {
    return hasPermission('settings', 'taxes', actionId);
  }, [hasPermission]);

  return {
    hasSettingsPagePermission,
    hasBranchPermission,
    hasTaxPermission
  };
};